export default {
    SideBySide: 'シンプルなサイドフォーム',
    Stacked: 'シンプルなスタックフォルム',
    email: 'Eメール',
    username: 'ユーザー名',
    usernameHelpText: 'アルファベット、数字、./+/-/_のみ。',
};
